import {ImageFilters} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/UyoControl/ImageFilters/ImageFilters';
import {Typography} from '~library/atoms/Typography';

export const FiltersSection = () => (
  <div className="uyo-control-section">
    <Typography variant="label2" className="uyo-control-section-title">
      FILTERS
    </Typography>
    <div className="uyo-control-filters-placeholder">
      <ImageFilters />
    </div>
  </div>
);
